export enum PublicRoutesTitles {
  SESSION_LOGIN = 'Session Login',
  LOGIN = 'Login',
  TWO_FACTOR = 'Two-Factor Authentication',
  FORGOT_PASSWORD = 'Forgot Password',
  RESET_PASSWORD = 'Reset Password',
  SERVICE_MAINTENANCE = 'Service Maintenance',
}
